export default __webpack_public_path__ + "locales/fi/ArchiveDialog.json?hash=2a662574589d49ab91001d5446aea7c8";